import { faMeta } from '@fortawesome/free-brands-svg-icons';
import { faRectangleAd } from '@fortawesome/pro-regular-svg-icons';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { DisplayCreative } from '@feathr/blackbox';
import { Icon, Well } from '@feathr/components';

import * as styles from './CreativeDimensionsWell.css';

interface ICreativeDimensionsWellProps {
  creative: DisplayCreative;
}

function CreativeDimensionsWell({ creative }: Readonly<ICreativeDimensionsWellProps>): JSX.Element {
  const { t } = useTranslation();
  const isMeta = creative.channel === 'meta';
  const spec = creative.getSpec();
  const width = creative.get('width');
  const height = creative.get('height');
  const dimensionsText = `${width}\u00D7${height}`;

  return (
    <Well
      className={styles.root}
      label={spec?.name ?? t('Unknown')}
      layout={'horizontal'}
      prefix={<Icon icon={isMeta ? faMeta : faRectangleAd} theme={'sky'} />}
    >
      <span className={styles.dimensions}>
        {dimensionsText} &middot; {creative.aspectRatio}
      </span>
    </Well>
  );
}

export default observer(CreativeDimensionsWell);
